export default "__VITE_ASSET__CnIvfszB__"